<script setup lang="ts">
import { useOverlay } from '../../composables/useOverlay';
import Button from '../button/Button.vue'
const overlay = useOverlay();

const iconSeverity = () => {
  switch (overlay?.dialog?.options?.confirmSeverity) {
    case 'primary':
      return { bg: 'bg-primary-400/10', text: 'text-primary-400' }
    case 'secondary':
      return { bg: 'bg-primary-850/10', text: 'text-primary-850' }
    case 'success':
      return { bg: 'bg-lime-450/10', text: 'text-lime-450' }
    case 'brown':
      return { bg: 'bg-primary-600/10', text: 'text-primary-600' }
    case 'danger':
      return { bg: 'bg-red-550/10', text: 'text-red-550' }
    case 'info':
      return { bg: 'bg-sky-350/10', text: 'text-sky-350' }
    case 'disabled':
      return { bg: 'bg-noir-50/10', text: 'text-noir-50' }
    case 'white':
      return { bg: 'bg-white/10', text: 'text-white' }
    default:
      return { bg: 'bg-primary-400/10', text: 'text-primary-400' }
  }
}
</script>

<template>
  <Teleport to="body">
    <TransitionGroup
      name="fade"
      tag="div"
    >
      <div
        v-if="overlay.dialog.options"
        class="fixed bg-black/60 flex justify-center items-center z-9999999 inset-0 backdrop-blur-xs px-4"
      >
        <div class="bg-primary-200 rounded-xl pl-4 pr-6 py-6 max-w-sm w-full shadow-xl ">
          <div class="flex items-start gap-3">
            <span
              class="p-3 rounded-full flex text-xl"
              :class="iconSeverity().bg"
            >
              <i
                v-if="overlay.dialog.options.icon"
                :class="[
                  overlay.dialog.options.icon,
                  iconSeverity().text
                ]"
              />
            </span>
            <div class="text-primary-900">
              <h3 class="text-xl font-bold">
                {{ overlay.dialog.options.title }}
              </h3>
              <p class="text-primary-900/70">
                {{ overlay.dialog.options.message }}
              </p>
            </div>
          </div>
          <div class="mt-4 flex justify-end gap-8">
            <Button
              variant="text"
              severity="brown"
              :passive="true"
              :label="overlay.dialog.options.cancelText ?? 'Cancel'"
              @click="overlay.resolveDialog(false)"
            />
            <Button
              :severity="overlay.dialog.options.confirmSeverity ?? 'primary'"
              :label="overlay.dialog.options.confirmText ?? 'OK'"
              @click="overlay.resolveDialog(true)"
            />
          </div>
        </div>
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(30px); }
</style>
